import removeClass from 'remove-class';
import addClass from 'add-class';
import SlugButtonGroup from './slug-button-group';
import CarouselSelector from './carousel-selector';
import TabbedContentSwapper from './content-swapper';

export default class PollywogClassBrowseView {

	constructor(element, isHomePage) {
		this.element = element;
		this.isHomePage = isHomePage;

		if (isHomePage)
			this.maxPosts = 3;
		else
			this.maxPosts = -1;

		this.init();
	}

	init() {
		// Bind functions so we can use them as callbacks
		this.ageGroupSelected = this.ageGroupSelected.bind(this);
		this.locationSelected = this.locationSelected.bind(this);
		this.startFetching    = this.startFetching.bind(this);
		this.doneFetching     = this.doneFetching.bind(this);

		// Cache the containing element for the dynamic content
		this.ageGroupResultsWrapper = this.element.querySelector('.age-group-results-wrapper');

		const ageGroupBtnsDesktop = this.element.querySelector('.age-group-btns');
		const ageGroupBtnsMobile = ageGroupBtnsDesktop.cloneNode();
		ageGroupBtnsMobile.innerHTML = ageGroupBtnsDesktop.innerHTML + ageGroupBtnsDesktop.innerHTML; // Double the number of buttons
		addClass(ageGroupBtnsDesktop, 'desktop');
		addClass(ageGroupBtnsMobile, 'mobile');
		ageGroupBtnsDesktop.parentNode.insertBefore(ageGroupBtnsMobile, ageGroupBtnsDesktop);

		// Initialize the age group slider for mobile
		CarouselSelector.create(ageGroupBtnsMobile, {
			onChange: (activeElement, index) => {
				const slug = activeElement.dataset.slug;
				if (index >= this.ageGroupButtonGroup.count())
					index -= this.ageGroupButtonGroup.count();
				this.ageGroupSelected(slug, index);
			}
		});

		// Initialize the button groups
		this.ageGroupButtonGroup = SlugButtonGroup.create(ageGroupBtnsDesktop, '.age-group-btn', this.ageGroupSelected);
		this.locationButtonGroup = SlugButtonGroup.create(this.element, '.active-frame .location-btn', this.locationSelected);

		// Get the currently selected slugs
		this.ageGroupSlug = this.ageGroupButtonGroup.getActiveSlug();
		this.locationSlug = this.locationButtonGroup.getActiveSlug();

		this.defaultLocationSlug = this.locationSlug;
		this.ageGroupIndex = this.ageGroupButtonGroup.getActiveIndex();
		this.locationIndex = this.locationButtonGroup.getActiveIndex();

		this.ageGroupCount = this.ageGroupButtonGroup.count();
		this.locationCount = this.locationButtonGroup.count();

		// Info we will need for api calls
		this.apiUrl = this.element.dataset.apiUrl;
		this.lang = this.element.dataset.lang;

		// Set up the content swappers
		this.titleSelector         = '.age-group-results-title > .swapping-content';
		this.btnsRowSelector       = '.age-group-results-btns-row > .swapping-content';
		this.resourcesSelector     = '.age-group-resources-wrapper > .swapping-content';
		this.classExcerptsSelector = '.class-excerpts > .swapping-content';

		const titleContent         = this.ageGroupResultsWrapper.querySelector(this.titleSelector);
		const btnsRowContent       = this.ageGroupResultsWrapper.querySelector(this.btnsRowSelector);
		const resourcesContent     = this.ageGroupResultsWrapper.querySelector(this.resourcesSelector);
		const classExcerptsContent = this.ageGroupResultsWrapper.querySelector(this.classExcerptsSelector);

		this.titleContentSwapper         = TabbedContentSwapper.create(titleContent);
		this.btnsRowContentSwapper       = TabbedContentSwapper.create(btnsRowContent);
		if (resourcesContent.children.length)
			this.resourcesContentSwapper = TabbedContentSwapper.create(resourcesContent);
		this.classExcerptsContentSwapper = TabbedContentSwapper.create(classExcerptsContent);

		this.initInnerClassExcerptContentSwapper();
	}

	initInnerClassExcerptContentSwapper() {
		const frame = this.classExcerptsContentSwapper.getFrameElementAt(this.ageGroupIndex);
		const numLocationButtons = this.locationButtonGroup.count();
		this.innerClassExcerptContentSwapper = TabbedContentSwapper.create(frame, {
			tabCount: numLocationButtons,
			defaultIndex: numLocationButtons - 1,
		});
	}

	ageGroupSelected(slug, index) {
		this.ageGroupSlug = slug;
		this.ageGroupChanged = true;
		this.locationSlug = this.defaultLocationSlug;
		this.locationChanged = false;
		this.ageGroupIndex = index;
		this.load();

		// Change the URL
		if (!this.isHomePage)
			window.history.replaceState({}, document.title, `?age_group=${slug}`);
	}

	locationSelected(slug, index) {
		this.locationSlug = slug || '';
		this.locationChanged = true;
		this.ageGroupChanged = false;
		this.locationIndex = index;
		this.load();
	}

	load() {
		this.startFetching();

		var args =
			`&age_group_slug=${this.ageGroupSlug}` +
			`&location_slug=${this.locationSlug}` +
			`&max_posts=${this.maxPosts}` +
			`&show_resources=${this.isHomePage}` +
			`&lang=${this.lang}`;

		const fetchedAt = Date.now();
		this.fetchedAt = fetchedAt;

		fetch(this.apiUrl + args, { method: 'get', credentials: 'same-origin' })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				// If this isn't the latest fetch, don't update now; let the other one update instead
				if (fetchedAt !== this.fetchedAt)
					return;

				if (data.error) {
					this.doneFetching();
					return;
				}

				// Grab the HTML out of our json data and insert it into the dom
				const newResultsElement = document.createElement('div');
				newResultsElement.innerHTML = data.payload;

				if (this.ageGroupChanged) {
					this.swapAndGoToSlide(this.titleContentSwapper,         newResultsElement, this.titleSelector,         this.ageGroupIndex);
					this.swapAndGoToSlide(this.btnsRowContentSwapper,       newResultsElement, this.btnsRowSelector,       this.ageGroupIndex);
					this.swapAndGoToSlide(this.classExcerptsContentSwapper, newResultsElement, this.classExcerptsSelector, this.ageGroupIndex);
					if (this.resourcesContentSwapper)
						this.swapAndGoToSlide(this.resourcesContentSwapper, newResultsElement, this.resourcesSelector,     this.ageGroupIndex);
					this.initInnerClassExcerptContentSwapper();
				}
				else {
					this.swapAndGoToSlide(this.innerClassExcerptContentSwapper, newResultsElement, this.classExcerptsSelector, this.locationIndex);
					this.classExcerptsContentSwapper.height = this.innerClassExcerptContentSwapper.height;
				}

				this.doneFetching();
			})
			.catch((error) => {
				if (error)
					console.error(error);

				this.doneFetching();
			});
	}

	startFetching() {
		this.fetching = true;
		addClass(this.ageGroupResultsWrapper, 'fetching');
	}

	doneFetching() {
		this.fetching = false;
		removeClass(this.ageGroupResultsWrapper, 'fetching');
	}

	isFetching() {
		return this.fetching;
	}

	swapAndGoToSlide(contentSwapper, newResultsElement, selector, index) {
		const newElement = newResultsElement.querySelector(selector);
		contentSwapper.swapContentAt(index, newElement.children);
		contentSwapper.setActiveIndex(index);
	}

	static create() {
		return new PollywogClassBrowseView(...arguments);
	}

}



// WEBPACK FOOTER //
// ./assets/scripts/browse-classes.js